module.exports = __webpack_public_path__ + "img/certificadoM6.29b5163d.png";